<template>
  <a-form :form="form" @submit="handleSubmit">
    <a-form-item label="Account name" >
      <a-input
        v-decorator="[
          'username',
          {
            rules: [{ required: true, message: 'Please input your account name!', whitespace: true }],
          },
        ]"
      />
    </a-form-item>
    <a-form-item label="Role" >
     
      <a-select
        :options="roles"
        :initial-value="roles[0]"
        v-decorator="[
          'role',
          {
            rules: [{ required: true, message: 'Please input your account name!', whitespace: true }],
          },
        ]"
      />
    </a-form-item>
    <a-form-item  label="Password" has-feedback>
      <a-input
        v-decorator="[
          'password',
          {
            rules: [
              {
                required: true,
                message: 'Please input your password!',
              },
              {
                validator: validateToNextPassword,
              },
            ],
          },
        ]"
        type="password"
      />
    </a-form-item>
    <a-form-item  label="Confirm Password" has-feedback>
      <a-input
        v-decorator="[
          'confirm',
          {
            rules: [
              {
                required: true,
                message: 'Please confirm your password!',
              },
              {
                validator: compareToFirstPassword,
              },
            ],
          },
        ]"
        type="password"
        @blur="handleConfirmBlur"
      />
    </a-form-item>
   
  </a-form>
</template>

<script>

export default {
  data() {
    return {
      confirmDirty: false,
      autoCompleteResult: [],
      roles:[
        {
          label:'User',
          value:'USER',
        },
        {
          label:'Admin',
          value:'ADMIN',
        }
      ]
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'register' });
  },
  methods: {
    handleSubmit(e) {
      // e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$emit('submit',values)
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        callback('Two passwords that you enter is inconsistent!');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
  },
};
</script>